import { MutationTree } from 'vuex';
import ILocalState from './stateInterface';

const mutations: MutationTree<ILocalState> = {
    setShoppingCartRecords(state, payload) {
        state.shoppingCartRecords = payload;
    },
    setShoppingListRecords(state, payload) {
        state.shoppingListRecords = payload;
    },
    setFilteredShoppingListRecords(state, payload) {
        state.filteredShoppingListRecords = payload;
    },
    setUserData(state, payload) {
        state.userData = payload;
    },
    authorizeUser(state) {
        state.isUserAuthorized = true;
    },
    unauthorizeUser(state) {
        state.isUserAuthorized = false;
    },
    logoutUser(state) {
        state.isUserAuthorized = false;
    },
    setCheckoutList(state, payload) {
        state.checkoutList = payload;
    },
    setProjectBillingsSubscription(state, payload) {
        state.projectBillingsSubscription = payload;
    },
    setProjectBillingsCredits(state, payload) {
        state.projectBillingsCredits = payload;
    },
    setActiveAccount(state, payload) {
        state.activeAccount = payload;
    },
    setBillingAddresses(state, payload) {
        state.billingAddresses = payload;
    },
    setBluesnapToken(state, payload) {
        state.bluesnapToken = payload;
    },
    setProjectBillings(state, payload) {
        state.projectBillings = payload;
    },
    setInvoices(state, payload) {
        state.invoices = payload;
    },
    setLoginRecords(state, payload) {
        state.loginRecords = payload;
    },
    setCurrentReportDetails(state, payload) {
        state.currentReportDetails = payload;
    },
    setCurrentStatisticalAnalysis(state, payload) {
        state.currentStatisticalAnalysis = payload;
    },
    setActiveProductGroup(state, payload) {
        state.activeProductGroup = payload;
    },
    setToken(state, payload) {
        state.token = payload;
    },
    setCountryList(state, payload) {
        state.countryList = payload;
    },
    setActiveCheckoutMethod(state, payload) {
        state.activeCheckoutMethod = payload;
    },
    setSwitchedUserEmail(state, payload) {
        state.switchedUserEmail = payload;
    },
    setCartSummary(state, payload) {
        state.cartSummary = payload;
    },
    setTrademarksShopListItems(state, payload) {
        state.trademarksShopListItems = payload;
    },
    setTrademarksShopCartItems(state, payload) {
        state.trademarksShopCartItems = payload;
    },
    setCustomerShopListItems(state, payload) {
        state.customerShopListItems = payload;
    },
    setCustomerShopCartItems(state, payload) {
        state.customerShopCartItems = payload;
    },
    setGoodwillShopListItems(state, payload) {
        state.goodwillShopListItems = payload;
    },
    setGoodwillShopCartItems(state, payload) {
        state.goodwillShopCartItems = payload;
    },
    setTechnologyShopListItems(state, payload) {
        state.technologyShopListItems = payload;
    },
    setTechnologyShopCartItems(state, payload) {
        state.technologyShopCartItems = payload;
    },
    setSoftwareShopListItems(state, payload) {
        state.softwareShopListItems = payload;
    },
    setSoftwareShopCartItems(state, payload) {
        state.softwareShopCartItems = payload;
    },
};

export default mutations;
